import { MapPin, Globe, ArrowUpRight } from "lucide-react";
import { useCookieConsent } from "../contexts/CookieConsentContext";

/**
 * MapEmbed — Google Maps iframe protejat cu gate de consimțământ.
 * Dacă utilizatorul nu a acceptat categoria „Conținut terț", afișează un
 * placeholder cu:
 *   - explicație clară că harta e găzduită de Google
 *   - buton „Afișează harta" (activează consimțământul pentru terți)
 *   - link direct către Google Maps (deschide în tab nou)
 */
export function MapEmbed({ src, title, mapsUrl, className = "" }) {
  const { consent, reopenPreferences } = useCookieConsent();
  const allowed = consent.thirdParty === true;

  if (allowed) {
    return (
      <iframe
        title={title}
        src={src}
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        className={className}
        allowFullScreen
        data-testid="map-embed-iframe"
      />
    );
  }

  return (
    <div
      className={`bg-brand-cream/60 border-2 border-dashed border-brand-yellow/70 flex flex-col items-center justify-center text-center p-6 gap-4 ${className}`}
      data-testid="map-embed-placeholder"
    >
      <div className="w-14 h-14 rounded-full bg-white shadow-sm flex items-center justify-center">
        <MapPin className="w-7 h-7 text-brand-red" />
      </div>
      <div className="max-w-md">
        <p className="font-display font-bold text-brand-navy text-base sm:text-lg">Harta este furnizată de Google</p>
        <p className="text-sm text-brand-navy/75 mt-2 leading-relaxed">
          Prin încărcarea hărții, Google poate seta module cookie proprii. Vă solicităm consimțământul înainte de a afișa acest conținut terț.
        </p>
      </div>
      <div className="flex flex-wrap gap-2 justify-center">
        <button
          type="button"
          onClick={reopenPreferences}
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-brand-red text-white text-sm font-semibold shadow-md hover:bg-brand-redSoft transition-colors"
          data-testid="map-embed-consent-button"
        >
          <Globe className="w-4 h-4" />
          Afișează harta
        </button>
        {mapsUrl && (
          <a
            href={mapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full bg-white border-2 border-brand-navy/20 text-brand-navy text-sm font-semibold hover:bg-brand-cream transition-colors"
            data-testid="map-embed-external-link"
          >
            Deschide în Google Maps
            <ArrowUpRight className="w-4 h-4" />
          </a>
        )}
      </div>
    </div>
  );
}
